import * as React from 'react';
import { connect } from 'react-redux';
import {
  Index,
  InfiniteLoader,
  InfiniteLoaderChildProps,
  List,
  ListRowProps,
} from 'react-virtualized';

import './HomePage.css';

import {
  fetchTrackPage,
  playClip,
  updateTrack,
} from '../thunks';

import { ITrack } from '../api';
import TrackRow from '../components/TrackRow';
import { RootState } from '../types';

interface IProps {
  currentTrack: string | null,
  fetchPage: (n: number) => void,
  isLoading: boolean,
  onMore: () => Promise<any>,
  onPlay: (id: string) => void,
  onEditFilename: (id: string, filename: string) => any,
  tracks: ITrack[],
  totalTracks: number | null,
}

interface IState {
  height: number,
  width: number,
}

class HomePage extends React.Component<IProps, IState> {

  public state = {
    height: 0,
    width: 0,
  }

  private container: HTMLDivElement | null;
  private list: List | null;

  public componentDidMount() {
    this.onResize();
  }

  public componentWillMount() {
    window.addEventListener('resize', this.onResize);

    this.props.fetchPage(0);
  }

  public componentWillUnmount() {
    window.removeEventListener('resize', this.onResize);
  }

  public componentDidUpdate(oldProps: IProps) {
    if (oldProps.currentTrack !== this.props.currentTrack && this.list) {
      this.list.forceUpdateGrid();
    }
  }

  public render() {
    const {
      height,
      width,
    } = this.state;
    const {
      tracks,
      totalTracks,
    } = this.props;

    return (<div className="home-page">
              <div className="track-list" ref={ this.onContainerRef }>
                <InfiniteLoader
                  loadMoreRows={this.loadMoreRows}
                  rowCount={totalTracks ? totalTracks + 1 : undefined}
                  isRowLoaded={this.isRowLoaded} >
                  {({ onRowsRendered, registerChild }: InfiniteLoaderChildProps) => (
                    <List
                      ref={ (el: List | null) => {
                        registerChild(el);
                        this.list = el;
                      } }
                      onRowsRendered={onRowsRendered}
                      height={height}
                      width={width}
                      containerStyle={{
                        marginBottom: 200,
                        marginTop: 30,
                        maxWidth: 900,
                      }}
                      rowHeight={30}
                      rowCount={tracks.length + 1}
                      overscanRowCount={5}
                      className="track-list-body"
                      rowRenderer={this.renderRow} />
                  )}
                </InfiniteLoader>
              </div>
            </div>);
  }

  private onResize = () => {
    const {container} = this;
    if (container) {
      this.setState({
        height: container.clientHeight,
        width: container.clientWidth,
      });
    }
  }

  private isRowLoaded = ({index}: Index) => {
    return this.props.tracks.length > index;
  }

  private loadMoreRows = () => {
    return this.props.onMore();
  }

  private onContainerRef = (el: HTMLDivElement) => {
    this.container = el;
  }

  private renderRow = ({
    index,
    key,
    style,
  }: ListRowProps) => {
    const {
      currentTrack,
      onPlay,
      tracks,
      onEditFilename,
      totalTracks,
    } = this.props;

    if (index === 0) {
      return (<div className="header-row">{
        totalTracks
        ? totalTracks.toLocaleString() + " Tracks"
        : null
      }</div>);
    }

    const track = tracks[index - 1];
    return (<TrackRow
      onPlay={ onPlay }
      onEditFilename={ onEditFilename }
      track={track}
      selected={track ? track.id === currentTrack : false}
      style={style}
      key={key}  />);
  }

}

export const HomePageContainer = connect(
  ({tracks, player}: RootState) => ({
    currentTrack: player.recordingId,
    isLoading: Object.keys(tracks.pages).findIndex(t => tracks.pages[t].loading) >= 0,
    totalTracks: tracks.total,
    tracks: Object.keys(tracks.data).map(t => tracks.data[t]),
  }),
  dispatch => ({
    fetchPage: (n: number) => { dispatch<any>(fetchTrackPage(n)) },
    onEditFilename: (trackID: string, filename: string) => dispatch<any>(updateTrack(trackID, {filename})),
    onMore: () => dispatch<any>(fetchTrackPage(null)),
    onPlay: (trackID: string) => { dispatch<any>(playClip({ recording_id: trackID })) },
  })
)(HomePage)

export default HomePage;



// WEBPACK FOOTER //
// ./src/pages/HomePage.tsx